export default "__VITE_ASSET__c48e57ad__"